import { createRouter, createWebHistory } from "vue-router";
import { computed } from "vue";
import { useToast, TYPE } from "vue-toastification";
import { ls } from "@/plugin/secure";
import { userStore } from "@/store/UserStore";
import menus from "./menus.json";
import i18n from "../plugin/i18n";

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/view/Login.vue"),
    meta: {},
  },
  {
    path: "/login_Call",
    name: "login_Call",
    component: () => import("@/view/Login_Call.vue"),
    meta: {},
  },
  {
    path: "/signUp",
    name: "signUp",
    component: () => import("@/view/SignUp.vue"),
    meta: {},
  },
  {
    path: "/signUp_Call",
    name: "signUp_Call",
    component: () => import("@/view/SignUp_Call.vue"),
    meta: {},
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/view/DashBoard.vue"),
    meta: {},
  },
  {
    path: "/map_page",
    name: "map_page",
    component: () => import("@/view/CurrentStatusMap.vue"),
    meta: {},
  },
  {
    path: "/map_page_mys",
    name: "map_page_mys",
    component: () => import("@/view/CurrentStatusMap_mys.vue"),
    meta: {},
  },
  {
    path: "/service/calendars_global",
    name: "service_calendar",
    component: () => import("@/view/ServiceCalendar_global.vue"),
    meta: {},
  },
  {
    path: "/setting/deleteUser",
    name: "setting_deleteUser",
    component: () => import("@/view/SettingDelete.vue"),
    meta: {},
  },
  {
    path: "/setting/deleteUser_Call",
    name: "setting_deleteUser_Call",
    component: () => import("@/view/SettingDelete_Call.vue"),
    meta: {},
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

function filteringMenus(defaultMenu, userMenu) {
  function filterMenu(menu) {
    const isMenuInUserMenu = userMenu.some((item) => item.vueFileUrl === menu.vueFileUrl);
    if (isMenuInUserMenu) {
      menu.component = () => import(`@/${menu.vueFileUrl.replace("_copy", "")}`);
      menu.meta.breadcrumb = computed(() =>
        i18n.global.t(`MENU_${menu.name.toUpperCase()}`)
      );
      const target = userMenu.find(
        (item) => item.vueFileUrl === menu.vueFileUrl
      );
      menu.meta.methods = target.methods;
    }
    if (menu.children) {
      menu.meta.breadcrumb = computed(() =>
        i18n.global.t(`MENU_${menu.name.toUpperCase()}`)
      );
      menu.children = menu.children.filter(filterMenu);
    } else {
      if (menu.vueFileUrl) {
        return isMenuInUserMenu;
      }
    }
    return (
      !menu.vueFileUrl ||
      isMenuInUserMenu ||
      (menu.children && menu.children.length > 0)
    );
  }

  return defaultMenu.filter(filterMenu);
}

let once = false;
router.beforeEach(async (to, from) => {
  const toast = useToast();
  const useUserStore = userStore();

  if(!useUserStore?.userInfo?.roleType)
  {
    await useUserStore.getUserData();
  }

  if (once == false && ls.get("menus")) {
    try {
      const menuData = filteringMenus(
        JSON.parse(JSON.stringify(menus)),
        JSON.parse(ls.get("menus"))
      );
      for(const route of menuData)
      {
        router.addRoute(route);
      }
        
/*
      menuData.forEach((route) => {
        router.addRoute(route);
      });
*/
      useUserStore.setMenus(menuData);
      if(!from.name)//뒤로가기 및 새로고침 오류 수정
      {
        router.push(to.path);
      }
    } catch {
      ls.clear();
      router.push("/");
    }
    once = true;
  } else {
    once = false;
  }

  if (!!ls.get("accessToken") == false && to.name !== "login") {
    if (to.name !== "signUp" && to.name !== "signUp_Call" && to.name !== "login_Call") {
      toast.warning(i18n.global.t("WARNING_NO_ACCESS_TOKEN"));
      useUserStore.directTargetPath = to.path;
      if(to.name === "setting_deleteUser_Call")  router.push("/login_Call");
      else router.push("/");
    }
  } else if (!!ls.get("accessToken") == true && to.name === "login") {
    try {
      router.push(JSON.parse(ls.get("page")));
    } catch {
      ls.clear();
      router.push("/");
    }
  } else if(!!ls.get("accessToken") == true && (to.name === "setting_deleteUser" || to.name === "setting_deleteUser_Call") && 
            (useUserStore?.userInfo?.roleType == "ACCOUNT" || useUserStore?.userInfo?.roleType == "ENGINEER" || useUserStore?.userInfo?.roleType == "ACCOUNT_MYS"))
  {
    try{
      router.push(JSON.parse(ls.get("page")));
    } catch {
      ls.clear();
      router.push("/");
    }
  }
});
export default router;
